<template>
  <div class="FAQs">
    <p class="FAQsTitle">How can we help?</p>
    <el-input size="large" type="text" v-model="input" placeholder="Search for keywords..."></el-input>
    <div class="FAQsQuestions">
      <el-collapse v-model="questionNames" @chang="handleChange">
        <el-collapse-item title="Questions about the product?" name="1">
          <div>1</div><div>1</div>
        </el-collapse-item>
        <el-collapse-item title="Questions about the product?" name="2">
          <div>1</div>
        </el-collapse-item>
        <el-collapse-item title="Questions about the product?" name="3">
          <div>1</div>
        </el-collapse-item>
        <el-collapse-item title="Questions about the product?" name="4">
          <div>1</div>
        </el-collapse-item>
      </el-collapse>
    </div>
  </div>
</template>

<script>
import {mapState,mapMutations} from 'vuex'
export default {
  name: 'top',
  data () {
    return {
      msg: '',
      lang:'zh-CN',
      input: '',
      questionNames: '',
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      
    })
  },
  computed: {
    
  },
  methods: {
    handleChange(){

    },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scope>
.FAQs{
    padding: 0;
    margin-top:40px;
    text-align:center;
    padding-bottom:80px;
}
.FAQs .FAQsTitle{
  font-family: Montserrat;
  font-size: 48px;
  font-style: normal;
  font-weight: 500;
  line-height: 59px;
  letter-spacing: 0em;
  text-align: center;
  margin-top: 106px;
}
.FAQs .el-input__inner{
  background: #FFFFFF;
  border: 1px solid #D5D5D5;
  box-sizing: border-box;
  border-radius: 10px;
  width: 615px;
  height: 79px;
  line-height: 79px;
  margin-top: 35px;
  font-size: 18px;
}
.FAQs .FAQsQuestions{
  margin: 130px 120px 0px 120px;
  text-align: left;
}
.el-collapse-item__header{
  font-size: 26px;
  padding-left: 20px;
  height: 80px;
  line-height: 80px;
}
.el-collapse-item__arrow{
  height: 80px;
  line-height: 80px;
}
.el-collapse-item__content{
  font-size: 18px;
  padding: 0px 0px 10px 40px;
}
@media only screen and (max-width: 768px){
  .FAQs .FAQsTitle{
    font-size: 36px !important;
  }
  .FAQs .el-input__inner{
    width: 80% !important;
  }
  .FAQs .FAQsQuestions{
    margin: 50px 20px 0px 20px !important;
  }
  .el-collapse-item__header{
    font-size: 16px !important;
  }
  .el-collapse-item__content{
    font-size: 14px !important;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/FAQs.vue